import React from 'react';
import { Input } from 'reactstrap';
import { deliveryOption } from 'pages/Orders/constant';

const DeliveryField = ({ ind, values, handleChange, label, required }) => {
  return (
    <div>
      <label>{label}</label>
      {required && <span style={{ color: 'red' }}>*</span>}

      <Input
        className="ps-0 shadow-none"
        id={`orderLogistics.${ind}.orderLogisticStatus`}
        name={`orderLogistics.${ind}.orderLogisticStatus`}
        type="select"
        value={values.orderLogistics?.[ind]?.orderLogisticStatus}
        onChange={handleChange}
      >
        {deliveryOption.map((option) => {
          return (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          );
        })}
      </Input>
    </div>
  );
};

export default DeliveryField;
